import type { ReactElement } from 'react';

import type { VideoProps } from './Video.types';

export const Video = ({ url, title }: VideoProps): ReactElement => {
  // YouTube
  if (url.includes('youtube') || url.includes('youtu.be')) {
    if (!url.includes('embed')) {
      console.warn('Video component: YouTube url should be embed url', url);
      return;
    }

    return (
      <iframe
        width="100%"
        height="100%"
        src={url}
        title={title}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      />
    );
  }

  // Vimeo
  if (url.includes('vimeo')) {
    if (!url.includes('player')) {
      console.warn('Video component: Vimeo url should be player url', url);
      return;
    }
    return (
      <iframe
        src={url}
        width="100%"
        height="100%"
        frameBorder="0"
        title={title}
        allow="autoplay; fullscreen; picture-in-picture"
        allowFullScreen
      />
    );
  }

  console.warn('Video component: Unsupported video url', url);
};
